 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-Account-vue":"view-Account-vue","view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6":"view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6","view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9":"view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9","view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue":"view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue","view-CreateBooking-vue":"view-CreateBooking-vue","view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a":"view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a","view-Calendar-vue":"view-Calendar-vue","view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9":"view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9","view-Report-vue":"view-Report-vue","view-UpdateBooking-vue":"view-UpdateBooking-vue","view-RequestedBookings-vue":"view-RequestedBookings-vue","view-EmailIndex-vue":"view-EmailIndex-vue","view-LocationIndex-vue":"view-LocationIndex-vue","view-PatientIndex-vue":"view-PatientIndex-vue","view-ProjectIndex-vue":"view-ProjectIndex-vue","view-UserIndex-vue":"view-UserIndex-vue","view-PermissionIndex-vue":"view-PermissionIndex-vue","view-PatientCreate-vue~view-PatientUpdate-vue":"view-PatientCreate-vue~view-PatientUpdate-vue","view-PatientCreate-vue":"view-PatientCreate-vue","view-PatientUpdate-vue":"view-PatientUpdate-vue","view-ProjectUpdate-vue":"view-ProjectUpdate-vue","view-EmailCreate-vue~view-EmailUpdate-vue":"view-EmailCreate-vue~view-EmailUpdate-vue","view-EmailCreate-vue":"view-EmailCreate-vue","view-EmailUpdate-vue":"view-EmailUpdate-vue","view-LocationCreate-vue~view-LocationUpdate-vue":"view-LocationCreate-vue~view-LocationUpdate-vue","view-LocationCreate-vue":"view-LocationCreate-vue","view-LocationUpdate-vue":"view-LocationUpdate-vue","view-Login-vue":"view-Login-vue","view-PermissionCreate-vue":"view-PermissionCreate-vue","view-ProjectCreate-vue":"view-ProjectCreate-vue","view-UserCreate-vue~view-UserUpdate-vue":"view-UserCreate-vue~view-UserUpdate-vue","view-UserCreate-vue":"view-UserCreate-vue","view-UserUpdate-vue":"view-UserUpdate-vue"}[chunkId]||chunkId) + "." + {"view-Account-vue":"8aad7352","view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6":"95f2cc2b","view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9":"4c4dbf03","view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue":"125f06fe","view-CreateBooking-vue":"8960f499","view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a":"a35dbe08","view-Calendar-vue":"ad1e4dde","view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9":"03294232","view-Report-vue":"16dec7a3","view-UpdateBooking-vue":"3589a670","view-RequestedBookings-vue":"54b408f6","view-EmailIndex-vue":"2a9fb58a","view-LocationIndex-vue":"c66dc7c7","view-PatientIndex-vue":"368c5aa4","view-ProjectIndex-vue":"e63a7053","view-UserIndex-vue":"93d1bf6b","view-PermissionIndex-vue":"7fd72d38","view-PatientCreate-vue~view-PatientUpdate-vue":"ec6ea839","view-PatientCreate-vue":"c85b6be9","view-PatientUpdate-vue":"a2b5e9b0","view-ProjectUpdate-vue":"57e6ee2b","view-EmailCreate-vue~view-EmailUpdate-vue":"1b5a7487","view-EmailCreate-vue":"7d47212a","view-EmailUpdate-vue":"b1f28049","view-LocationCreate-vue~view-LocationUpdate-vue":"d6c123da","view-LocationCreate-vue":"7ab72551","view-LocationUpdate-vue":"6a4b8256","view-Login-vue":"5a8aa73f","view-PermissionCreate-vue":"2144d286","view-ProjectCreate-vue":"dfc058be","view-UserCreate-vue~view-UserUpdate-vue":"6c618b45","view-UserCreate-vue":"d4c86af1","view-UserUpdate-vue":"0407a8a0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-Account-vue":1,"view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6":1,"view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9":1,"view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue":1,"view-CreateBooking-vue":1,"view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a":1,"view-Calendar-vue":1,"view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9":1,"view-Report-vue":1,"view-UpdateBooking-vue":1,"view-RequestedBookings-vue":1,"view-EmailIndex-vue":1,"view-LocationIndex-vue":1,"view-PatientIndex-vue":1,"view-ProjectIndex-vue":1,"view-UserIndex-vue":1,"view-PermissionIndex-vue":1,"view-PatientCreate-vue~view-PatientUpdate-vue":1,"view-ProjectUpdate-vue":1,"view-EmailCreate-vue~view-EmailUpdate-vue":1,"view-LocationCreate-vue~view-LocationUpdate-vue":1,"view-Login-vue":1,"view-PermissionCreate-vue":1,"view-ProjectCreate-vue":1,"view-UserCreate-vue~view-UserUpdate-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-Account-vue":"view-Account-vue","view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6":"view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6","view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9":"view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9","view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue":"view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue","view-CreateBooking-vue":"view-CreateBooking-vue","view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a":"view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a","view-Calendar-vue":"view-Calendar-vue","view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9":"view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9","view-Report-vue":"view-Report-vue","view-UpdateBooking-vue":"view-UpdateBooking-vue","view-RequestedBookings-vue":"view-RequestedBookings-vue","view-EmailIndex-vue":"view-EmailIndex-vue","view-LocationIndex-vue":"view-LocationIndex-vue","view-PatientIndex-vue":"view-PatientIndex-vue","view-ProjectIndex-vue":"view-ProjectIndex-vue","view-UserIndex-vue":"view-UserIndex-vue","view-PermissionIndex-vue":"view-PermissionIndex-vue","view-PatientCreate-vue~view-PatientUpdate-vue":"view-PatientCreate-vue~view-PatientUpdate-vue","view-PatientCreate-vue":"view-PatientCreate-vue","view-PatientUpdate-vue":"view-PatientUpdate-vue","view-ProjectUpdate-vue":"view-ProjectUpdate-vue","view-EmailCreate-vue~view-EmailUpdate-vue":"view-EmailCreate-vue~view-EmailUpdate-vue","view-EmailCreate-vue":"view-EmailCreate-vue","view-EmailUpdate-vue":"view-EmailUpdate-vue","view-LocationCreate-vue~view-LocationUpdate-vue":"view-LocationCreate-vue~view-LocationUpdate-vue","view-LocationCreate-vue":"view-LocationCreate-vue","view-LocationUpdate-vue":"view-LocationUpdate-vue","view-Login-vue":"view-Login-vue","view-PermissionCreate-vue":"view-PermissionCreate-vue","view-ProjectCreate-vue":"view-ProjectCreate-vue","view-UserCreate-vue~view-UserUpdate-vue":"view-UserCreate-vue~view-UserUpdate-vue","view-UserCreate-vue":"view-UserCreate-vue","view-UserUpdate-vue":"view-UserUpdate-vue"}[chunkId]||chunkId) + "." + {"view-Account-vue":"4afeb507","view-Calendar-vue~view-CreateBooking-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientInde~3d1cb5c6":"e4d4b8b8","view-Calendar-vue~view-CreateBooking-vue~view-PatientCreate-vue~view-PatientUpdate-vue~view-Report-v~e1c05fd9":"563d87fb","view-Calendar-vue~view-CreateBooking-vue~view-ProjectUpdate-vue~view-Report-vue":"86eb1cb4","view-CreateBooking-vue":"9543857f","view-Calendar-vue~view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-ProjectIndex~4db7022a":"df9e6004","view-Calendar-vue":"96c39665","view-EmailIndex-vue~view-LocationIndex-vue~view-PatientIndex-vue~view-PermissionIndex-vue~view-Proje~b7ab99e9":"b4bba067","view-Report-vue":"d053d254","view-UpdateBooking-vue":"c495f319","view-RequestedBookings-vue":"eccc755c","view-EmailIndex-vue":"91bd8647","view-LocationIndex-vue":"840f6f25","view-PatientIndex-vue":"eeb622f3","view-ProjectIndex-vue":"840f6f25","view-UserIndex-vue":"16c83368","view-PermissionIndex-vue":"b46b3b98","view-PatientCreate-vue~view-PatientUpdate-vue":"93e902ff","view-PatientCreate-vue":"31d6cfe0","view-PatientUpdate-vue":"31d6cfe0","view-ProjectUpdate-vue":"c84867b1","view-EmailCreate-vue~view-EmailUpdate-vue":"bca33ea0","view-EmailCreate-vue":"31d6cfe0","view-EmailUpdate-vue":"31d6cfe0","view-LocationCreate-vue~view-LocationUpdate-vue":"fb406f6e","view-LocationCreate-vue":"31d6cfe0","view-LocationUpdate-vue":"31d6cfe0","view-Login-vue":"2fb49ab4","view-PermissionCreate-vue":"ccf2b2a6","view-ProjectCreate-vue":"afda10e2","view-UserCreate-vue~view-UserUpdate-vue":"ad77bf3b","view-UserCreate-vue":"31d6cfe0","view-UserUpdate-vue":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
